export default __webpack_public_path__ + "static/media/A98.7e488cdd.png";